import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import { Scale } from "lucide-react";

export default function LegalNotes() {
  return (
    <div>
      <SEO title="Note legali" description="Note legali di Smart News Italia: natura del progetto, proprietà dei materiali di terzi e uso dell'intelligenza artificiale." />
      <PageHero crumb="Note legali" overline="Note legali" title="Note legali" subtitle="Informazioni sulla natura del progetto, sulla proprietà dei contenuti di terzi e sull'uso dell'intelligenza artificiale." icon={Scale} />
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-12 space-y-8 text-sm leading-relaxed text-muted-foreground">
        <p className="text-xs">Ultimo aggiornamento: 15 agosto 2026</p>

        <section className="space-y-2">
          <h2 className="font-serif text-xl font-bold text-foreground">Natura del progetto</h2>
          <p>Smart News Italia è un progetto indipendente dedicato alla traduzione in italiano e alla raccolta di discorsi, dichiarazioni e conferenze stampa diffusi da fonti istituzionali. Le traduzioni sono curate dal progetto e non costituiscono versioni ufficiali delle istituzioni citate.</p>
          <p>Smart News Italia non è una testata giornalistica registrata.</p>
          <p>Le informazioni relative al titolare del trattamento sono disponibili nella <a className="text-primary hover:underline" href="/privacy-policy">Privacy Policy</a>.</p>
        </section>

        <section className="space-y-2">
          <h2 className="font-serif text-xl font-bold text-foreground">Materiali di terzi e diritti d'autore</h2>
          <p>I diritti sui video, sulle immagini e sugli altri materiali provenienti da terzi appartengono ai rispettivi titolari. La fonte originale viene indicata in ogni contenuto. L'utilizzo dei materiali deve rispettare le licenze, le autorizzazioni e la normativa applicabile.</p>
          <p>Per richieste relative a diritti d'autore o alla rimozione dei contenuti puoi scrivere a <a className="text-primary hover:underline" href="mailto:contatti@smartnewsitalia.it">contatti@smartnewsitalia.it</a>.</p>
        </section>

        <section className="space-y-2">
          <h2 className="font-serif text-xl font-bold text-foreground">Uso dell'intelligenza artificiale</h2>
          <p>Traduzione, doppiaggio ed eventuale sincronizzazione labiale sono realizzati con strumenti di intelligenza artificiale. Il contenuto del discorso non viene riscritto. L'obiettivo è preservare fedelmente il significato originale; nonostante la revisione, possono verificarsi errori, che possono essere segnalati attraverso gli strumenti presenti sul sito. Consulta sempre il video e la fonte originale.</p>
        </section>
      </div>
    </div>
  );
}
